import { Box, Typography } from "@mui/joy";
import { formatDistanceToNow } from "date-fns";

function NewsFooter({ author, publishedAt }) {
  return (
    <Box sx={{ mt: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 0.5 }}>
        <Typography level="body-xs" sx={{ fontStyle: 'italic' }}>
          By {author}
        </Typography>
        <Typography level="body-xs" sx={{ color: 'neutral.500' }}>
          {formatDistanceToNow(publishedAt, { addSuffix: true })}
        </Typography>
      </Box>
    </Box>
  );
}

export default NewsFooter;